import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { getItem } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaUndoAltSolid } from "react-icons/lia";
import { RxReload } from "react-icons/rx";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import Select from "react-select";

function AllAudio_Playlist() {
  const { fetchRequest, deleteImageFile } = useMyContext();
  const userRole = getItem('role');
  const BaseUrl = process.env.REACT_APP_Baseurl;
  const listApi = `${BaseUrl}/admin/audio/playlist/index`;
  const multiDeleteApi = `${BaseUrl}/admin/audio/playlist/multi-delete`;
  const usersListApi = `${BaseUrl}/admin/users/list`;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState('');
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false);
  const [usersOptions, setUsersOptions] = useState([]);
  // Default the filter to the logged-in user's own data.
  const loggedUserId = getItem('user_id');
  const [selectedUser, setSelectedUser] = useState(loggedUserId || "");
  const [formData, setFormData] = useState({ title: "" });

  // Default view = the logged-in user's own playlists (editable). Selecting a *different*
  // user lists that user's playlists read-only. The "Admin Playlists" option (value "") is editable too.
  const isUserView = !!selectedUser && String(selectedUser) !== String(loggedUserId);

  const fetchUsers = async () => {
    try {
      const response = await fetchRequest({
        method: 'GET',
        url: usersListApi,
        params: {},
        data: {},
      });
      const list = response?.data || [];
      // A Super Admin (role 5) sees every name; lower admins don't see the Super Admin.
      const isSuperAdmin = String(userRole) === "5";
      setUsersOptions(list
        .filter((u) => isSuperAdmin || String(u?.role) !== "5")
        .map((u) => ({
          value: u?.id,
          label: u?.username || u?.name || u?.email || `User ${u?.id}`,
        })));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        page,
        limit: formData?.title ? total?.totalItems : limit,
        search: formData?.title,
        ...(selectedUser ? { user_id: selectedUser } : {}),
      },
      data: {},
    })
      .then(response => {
        const result = response;
        setApiData(result?.data || []);
        setPage(result?.pagination?.currentPage || 1);
        setTotal(result?.pagination);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "AdminAudioPlaylist");
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    await handleDeleteImage();
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDeleteApi}`,
      params: {},
      data: { id: itemToDelete },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([]);
          setShowOverlay(false);
        }
        else {
          toast.error(result?.message);
          setShowOverlay(false);
        }
      })
      .catch(error => {
        setShowOverlay(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleSizePerPageChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const closeModal = () => {
    setModelClose(false);
    setItemToDelete([]);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    setModelClose(false);
  };

  const reloadAction = () => {
    setWithoutRefresh(prev => !prev);
  };

  const columns = [
    {
      dataField: "title",
      text: "Playlist Name",
      width: "40%",
      colStyle: "px-5",
      formatter: (cell, row) => {
        const imageUrl = row?.image;
        const title = row?.title;
        const displayTitle = title?.length > 20 ? `${title?.slice(0, 20)}...` : title;
        return (
          <div className="d-flex justify-content-between align-items-center">
            {imageUrl ? (
              <img key={imageUrl} src={imageUrl} alt={title} className="profile theme-bg-color-secondary" />
            ) : (
              <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                {title?.slice(0, 1)?.toUpperCase()}
              </div>
            )}
            <div className="rightVideoTitle ms-2">
              <span className="theme-text-color table-heading d-flex align-items-center" title={row?.slug}>{displayTitle}</span>
              <span className="dateText table-subheading theme-text-color">{row?.upload_on}</span>
            </div>
          </div>
        );
      },
      sort: true,
    },
    {
      dataField: "created_by_name",
      text: "Created By",
      width: "20%",
      colStyle: "px-4",
      formatter: (cell, row) => <span className="theme-text-color">{row?.created_by_name || "Admin"}</span>,
    },
    {
      dataField: "audio_count",
      text: "Tracks",
      width: "15%",
      rowStyle: "px-4",
      formatter: (cell, row) => <span className="theme-text-color">{row?.audio_count ?? 0}</span>,
    },
    {
      dataField: "type",
      text: "Type",
      colStyle: "px-5",
      formatter: (cell, row) => <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${row?.is_user_playlist ? "UNPUBLISHED_active" : "PUBLISHED_active"}`}>{row?.is_user_playlist ? "User" : "Admin"}</div>,
    },
    // Edit / Delete for all playlists in admin view.
    ...((userRole == 1) ? [{
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className="editdropdown-menu theme-bg-color">
            <Link id="audio-playlist-edit-link" to={`/edit-audio-playlist/${row?.id}`} className="theme-text-color theme-bg-color">
              <span className="theme-text-color">
                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Edit" classname='ms-2 theme-text-color' />
              </span>
            </Link>
            <div id="audio-playlist-delete-action" onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
              <MessageBox text="Delete" classname='ms-2 theme-text-color' />
            </div>
          </div>
        </div>
      ),
    }] : []),
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: 'All', value: total?.totalItems }
    ]
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const handleUserChange = (value) => {
    setSelectedUser(value);
    setItemToDelete([]);
    setPage(1);
  };

  // Options for the searchable user filter ("All Users" + each user).
  const userFilterOptions = [{ value: "", label: "All Users" }, ...usersOptions];
  const selectedUserOption = userFilterOptions.find((o) => String(o.value) === String(selectedUser)) || null;

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, selectedUser]);

  return (
    <>
      <div className="">
        {showOverlay && <Response_Processing />}
        {modelClose && <AdminDeleteModal
          headingText={"Confirm Delete"}
          message={"Are you sure you want to delete the selected item ?"}
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleDeletedata}
          buttonText={"custom"}
          actionText={"Delete"}
        />}
        <AdminNavbar heading="Audio Playlist" totalDataLength={total?.totalItems} deleteCount={itemToDelete?.length} deleteMethod={openModal} {...(userRole == 1 && { navigation: "/add-audio-playlist", navText: "Audio Playlist" })} />
        <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width">
          <div className='theme-bg-color p-3 rounded-3 mb-5'>
            <div className='d-flex align-items-center gap-2 flex-wrap mb-3'>
              <input type='search' id="audio-playlist-search-input" placeholder='Search' name="title" className='rounded-3 theme-border-color border-solid-width border-solid table-search theme-bg-color-secondary' onChange={handleInput} />
              <Select
                inputId="audio-playlist-user-filter"
                classNamePrefix="select"
                className="custom-select-multi m-0"
                placeholder="Search user…"
                isSearchable
                options={userFilterOptions}
                value={selectedUserOption}
                onChange={(opt) => handleUserChange(opt?.value ?? "")}
                noOptionsMessage={() => "No user found"}
                styles={{
                  container: (base) => ({ ...base, minWidth: 240, maxWidth: 300 }),
                  // Match the search input: visible rounded border + comfortable height.
                  control: (base, state) => ({
                    ...base,
                    minHeight: 48,
                    borderRadius: "0.5rem",
                    borderColor: "#dee2e6",
                    boxShadow: state.isFocused ? "0 0 0 1px #dee2e6" : "none",
                    "&:hover": { borderColor: "#dee2e6" },
                  }),
                  // Keep the typed search text, selected value and placeholder visible on the white control.
                  input: (base) => ({ ...base, color: "#333", opacity: 1 }),
                  singleValue: (base) => ({ ...base, color: "#333" }),
                  placeholder: (base) => ({ ...base, color: "#808080" }),
                }}
              />
              <div className='d-flex align-items-center ms-auto'>
                {(userRole == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg me-2"} saveMethod={() => setModelClose(true)} /> : ""}
                <button id="audio-playlist-reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 primary border border-2 rounded-circle theme-border-color`} onClick={reloadAction}>
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                </button>
              </div>
            </div>

            <AdminTable
              data={apiData}
              loading={loading}
              options={options}
              handlePageChange={handlePageChange}
              page={page}
              pagination={total}
              handleSizePerPageChange={handleSizePerPageChange}
              columns={columns}
              limit={limit}
              selectRow={selectRow}
              multiSelect={userRole == 1}
              onRowSelect={handleRowSelect}
              onSort={handleSort}
              onSelectAll={handleSelectAll}
              viewType={"list"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AllAudio_Playlist;
